<template>
  <div class="group">
    <h1>{{ this.$route.name.toUpperCase().replace("-", " ") }}</h1>
    <div class="collections">
      <div class="group-collections" v-for="(item, index) in this.$data[this.$route.name]" v-bind:key=index>
        <router-link :to="item.route" v-on:click.native="toggle = false">{{ item.title }}</router-link>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
     'resort': [
      {
       'route': '/collection/swimwear',
       'title': 'Swimwear',
      }
     ],
     'winter-style': [
      {
        'route': '/collection/FW20',
        'title': 'FW2023',
      },
      {
        'route': '/collection/FW21-22',
        'title': 'FW2024'
      },
      {
        'route': '/collection/fall-2022',
        'title': 'FW2025'
      },
     ],
     'summer-style': [
      {
        'route': '/collection/SS2023',
        'title': 'SS2023'
      },
      {
        'route': '/collection/SS2024',
        'title': 'SS2024'
      },
      {
        'route': '/collection/SS2025',
        'title': 'SS2025'
      },
     ],
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Kate Mack - Collections',
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack - Collections',
    meta: [
      {
        property: 'og:title',
        content: 'Kate Mack',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - ${this.$data[this.$route.name].title}`,
        vmid: 'og:title'
      }
    ]
  },
}
</script>

<style lang="scss" scoped>
div.group {
  width: 100%;
  flex: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  align-items: center;
}
div.collections {
  flex: 1;
  display: flex;
  height: 100vh;
  flex-wrap:nowrap;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  div.group-collections {
    a {
      border: 2px solid #ffffff;
      border-radius: 5px;
      text-align: center;
      text-decoration: none;
      padding: 1rem;
      vertical-align: middle;
      &:hover {
        color: #000;
        background-color: #fff;
      }
    }
  }
}
</style>
